<template>
  <div class="component-modal modal-large" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{$t("modal.spot_programming.spot.detailedSchedule.title")}}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>

      <div class="component-modal__row--half">
        <div class="component-modal__column--half component-modal__row__multiselect">
            <label for="spotType">{{$t("modal.spot_programming.spot.detailedSchedule.spotType")}}</label>
            <Multiselect
              v-model="model.spotType"
              :placeholder="$t('modal.spot_programming.spot.detailedSchedule.spotType')"
              :searchable="false"
              :canDeselect="false"
              :canClear="false"
              :options="[
                { value: 0, label: `${$t('modal.spot_programming.spot.options.spotType.audio')}` },
                { value: 1, label: `${$t('modal.spot_programming.spot.options.spotType.nonTraditionalSpot')}` },
                { value: 2, label: `${$t('modal.spot_programming.spot.options.spotType.sponsorship')}` },
              ]"
              @select="model.spotType == 0 ? model.ntcText = '' : ''" />

            <!-- <select name="spotType" id="spotType" v-model="model.spotType" @change="model.spotType == 0 ? model.ntcText = '' : ''">
              <option :value="0">{{$t("modal.spot_programming.spot.options.spotType.audio")}}</option>
              <option :value="1">{{$t("modal.spot_programming.spot.options.spotType.nonTraditionalSpot")}}</option>
              <option :value="2">{{$t("modal.spot_programming.spot.options.spotType.spot")}}</option>
            </select> -->
        </div>
        <div class="component-modal__column--half component-modal__row__multiselect">
          <label for="position">{{$t("modal.spot_programming.spot.detailedSchedule.spotPosition")}}</label>
          <Multiselect
              v-model="model.commercialBreakSpotPosition"
              :placeholder="$t('modal.placeholder_select')+$t('modal.spot_programming.spot.detailedSchedule.spotPosition')"
              :searchable="false"
              :canDeselect="false"
              :canClear="false"
              :options="[
                { value: 0, label: `${$t('modal.spot_programming.spot.options.spotPosition.first')}` },
                { value: 1, label: `${$t('modal.spot_programming.spot.options.spotPosition.second')}` },
                { value: 10, label: `${$t('modal.spot_programming.spot.options.spotPosition.third')}` },
                { value: 11, label: `${$t('modal.spot_programming.spot.options.spotPosition.fourth')}` },
                { value: 12, label: `${$t('modal.spot_programming.spot.options.spotPosition.fifty')}` },
                { value: 2, label: `${$t('modal.spot_programming.spot.options.spotPosition.indistict')}` },
                { value: 22, label: `${$t('modal.spot_programming.spot.options.spotPosition.penultimate')} ${$t('modal.spot_programming.spot.options.spotPosition.fourth')}` },
                { value: 21, label: `${$t('modal.spot_programming.spot.options.spotPosition.penultimate')} ${$t('modal.spot_programming.spot.options.spotPosition.third')}` },
                { value: 20, label: `${$t('modal.spot_programming.spot.options.spotPosition.penultimate')} ${$t('modal.spot_programming.spot.options.spotPosition.second')}` },
                { value: 3, label: `${$t('modal.spot_programming.spot.options.spotPosition.penultimate')} ${$t('modal.spot_programming.spot.options.spotPosition.first')}` },
                { value: 4, label: `${$t('modal.spot_programming.spot.options.spotPosition.last')}` }
              ]"
              :style="{'color': !model.commercialBreakSpotPosition ? '#757575' : '#ffffffde'}" />

            <!-- <select name="position" id="position" v-model="model.commercialBreakSpotPosition" >
              <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.detailedSchedule.spotPosition")}}</option>
              <option :value="1">{{$t("modal.spot_programming.spot.options.spotPosition.first")}}</option>
              <option :value="2">{{$t("modal.spot_programming.spot.options.spotPosition.second")}}</option>
              <option :value="3">{{$t("modal.spot_programming.spot.options.spotPosition.third")}}</option>
              <option :value="4">{{$t("modal.spot_programming.spot.options.spotPosition.fourth")}}</option>
              <option :value="5">{{$t("modal.spot_programming.spot.options.spotPosition.fifty")}}</option>
              <option :value="6">{{$t("modal.spot_programming.spot.options.spotPosition.indistict")}}</option>
              <option :value="7">{{$t("modal.spot_programming.spot.options.spotPosition.penultimate")}} {{$t("modal.spot_programming.spot.options.spotPosition.fourth")}}</option>
              <option :value="8">{{$t("modal.spot_programming.spot.options.spotPosition.penultimate")}} {{$t("modal.spot_programming.spot.options.spotPosition.third")}}</option>
              <option :value="9">{{$t("modal.spot_programming.spot.options.spotPosition.penultimate")}} {{$t("modal.spot_programming.spot.options.spotPosition.second")}}</option>
              <option :value="10">{{$t("modal.spot_programming.spot.options.spotPosition.penultimate")}} {{$t("modal.spot_programming.spot.options.spotPosition.first")}}</option>
              <option :value="11">{{$t("modal.spot_programming.spot.options.spotPosition.last")}}</option>
            </select> -->
        </div>
      </div>

    
      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="spotFileName" id="spotFileName" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t(`modal.spot_programming.spot.detailedSchedule.${model.spotType == 1 ? 'titleMention' : 'spotFileName'}`)" v-model="model.fileName"  :class="{'invalid': submitted && v$.model.fileName.$invalid}">
          <label for="spotFileName">{{$t(`modal.spot_programming.spot.detailedSchedule.${model.spotType == 1 ? 'titleMention' : 'spotFileName'}`)}}
            <small v-if="submitted && v$.model.fileName.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row--third">
        <div class="component-modal__column--third">
          <div class="component-modal-input component-modal-input--rename">
            <input type="number" name="length" id="length" autocomplete="off" :placeholder="$t('modal.placeholder_insert')" v-model="model.length" :class="{'invalid': submitted && v$.model.length.$invalid}">
            <label for="length">
              {{$t("modal.spot_programming.spot.detailedSchedule.length")}}
              <small v-if="submitted && v$.model.length.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
              <small class="time" v-if="model.length > 0">{{calculateTime(model.length)}}</small>
            </label>
          </div>
        </div>

        <div class="component-modal__column--third component-modal__row__multiselect">
          <!-- <div class="component-modal-input component-modal-input--rename"> -->
            <label for="product">{{$t("modal.spot_programming.spot.simpleSchedule.product")}}
              <small v-if="submitted && v$.model.productId.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
            </label>
            <Multiselect
              v-model="model.productId"
              :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.simpleSchedule.product')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :canDeselect="false"
              :canClear="false"
              :options="listProducts" 
              @select="updateProduct"
              :class="{'invalid': submitted && v$.model.productId.$invalid}"/>
            <!-- <select name="product" id="product" v-model="model.productId" @change="updateProduct" :class="{'invalid': submitted && v$.model.productId.$invalid}">
              <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.simpleSchedule.product")}}</option>
              <option v-for="product in listProducts" :key="product.id" :value="product.id">{{product.name}} | ${{product.price}}</option>
            </select> -->
          <!-- </div> -->
        </div> 

        <div class="component-modal__column--third">
          <div class="component-modal-input component-modal-input--rename">
            <input type="text" name="price" id="price" autocomplete="off" :placeholder="$t('modal.placeholder_insert')" v-model="model.price">
            <label for="price">{{$t("modal.spot_programming.spot.detailedSchedule.price")}}
              <small v-if="comparePriceProduct(model.productId, model.price)" class="pill-required" style="background: #ffc107; margin-left: 4px" :title="$t('modal.spot_programming.spot.detailedSchedule.price_title')">{{$t("modal.spot_programming.spot.detailedSchedule.price_info")}}</small> 
            </label>
          </div>
        </div> 
      </div>

      <div class="component-modal__row--half">
        <div class="component-modal__column--half">
          <div class="component-modal-input component-modal-input--rename">
            <input type="time"  v-model="model.startTime" @change="validateTimes" @focus="$event.target.select()" :class="{'invalid': submitted && (v$.model.startTime.$invalid || invalidDates)}">
            <label for="start">{{$t("modal.spot_programming.spot.detailedSchedule.startTime")}}
              <small v-if="submitted && (v$.model.startTime.$invalid || invalidDates)" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
            </label>
          </div>
        </div>

        <div class="component-modal__column--half">
          <div class="component-modal-input component-modal-input--rename">
            <input type="time"  v-model="model.endTime" @change="validateTimes" @focus="$event.target.select()" :class="{'invalid': submitted && (v$.model.endTime.$invalid || invalidDates)}">
            <label for="end">{{$t("modal.spot_programming.spot.detailedSchedule.endTime")}}
              <small v-if="submitted && (v$.model.endTime.$invalid || invalidDates)" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
            </label>
          </div>
        </div>
      </div>
      
      <div class="component-modal__row--half">
        <div class="component-modal__column--half">
          <div class="component-modal-input component-modal-input--rename">
            <input type="text" name="timeFee" id="timeFee" autocomplete="off" :placeholder="$t('modal.placeholder_insert')" v-model="model.timeFee">
            <label for="timeFee">{{$t("modal.spot_programming.spot.detailedSchedule.timeFee")}}</label>
          </div>
        </div>
        <div class="component-modal__column--half component-modal__row__multiselect">
          <!-- <div class="component-modal-input component-modal-input--rename"> -->
            <label for="speaker">{{$t("modal.spot_programming.spot.detailedSchedule.speaker")}}</label>
            <Multiselect
              v-model="model.speakerId"
              :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.detailedSchedule.speaker')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :options="listspeakers" />

            <!-- <select name="speaker" id="speaker" v-model="model.speakerId">
              <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.detailedSchedule.speaker")}}</option>
              <option v-for="speaker in listspeakers" :key="speaker.id" :value="speaker.id">{{speaker.code}} - {{speaker.name}}</option>
            </select> -->
          <!-- </div> -->
        </div>
      </div>

      <template v-if="model.startTime != '' && model.endTime != ''">
        <!-- Alert validation -->
        <div class="alert warning" v-if="invalidDates">
          <i class="material-icons">info_outline</i>
          {{$t("modal.station_config.schedules.errorTime")}}
        </div>
      </template>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <textarea :disabled="model.spotType == 0" name="NTCText" id="NTCText" cols="30" rows="3" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.spot.detailedSchedule.text')" v-model="model.ntcText" @change="calculateTimeMention" class="unformatted"></textarea>
          <label for="NTCText">{{$t("modal.spot_programming.spot.detailedSchedule.text")}}</label>
        </div>
      </div>

      <!-- Business -->
      <div class="component-modal-section">
        <strong>{{$t("modal.spot_programming.spot.detailedSchedule.business")}}</strong>
        <div class="component-modal__row--third">
          <div class="component-modal__column--third component-modal__row__multiselect">
            <!-- <div class="component-modal-input component-modal-input--rename"> -->
              <label for="name">{{$t("modal.spot_programming.spot.detailedSchedule.show")}}</label>
              <Multiselect
              v-model="model.idBusinessShow"
              :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.detailedSchedule.show')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :options="listPrograms" />

              <!-- <select name="" id="" v-model="model.idBusinessShow">
                <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.detailedSchedule.show")}}</option>
                <option v-for="show in listPrograms" :key="show.id" :value="show.id">{{show.code}} - {{show.name}}</option>
              </select> -->
            <!-- </div> -->
          </div>
          <div class="component-modal__column--third component-modal__row__multiselect">
            <!-- <div class="component-modal-input component-modal-input--rename"> -->
              <label for="name">{{$t("modal.spot_programming.spot.detailedSchedule.unit")}}</label>
              <Multiselect
              v-model="model.businessUnitId"
              :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.detailedSchedule.unit')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :options="listBusinessUnit" />

              <!-- <select name="" id="" v-model="model.businessUnitId">
                <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.detailedSchedule.unit")}}</option>
                <option v-for="business in listBusinessUnit" :key="business.id" :value="business.id">{{business.code}} - {{business.description}}</option>
              </select> -->
            <!-- </div> -->
          </div>

          <div class="component-modal__column--third">
            <div class="component-modal-input component-modal-input--rename">
              <input type="number" name="name" id="name" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.spot.detailedSchedule.monthlyFee')" v-model="model.businessMonthlyFee">
              <label for="name">{{$t("modal.spot_programming.spot.detailedSchedule.monthlyFee")}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ props ? $t("modal.save") : $t('modal.create') }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && v$.model.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.model.$silentErrors.map(error => $t(`modal.spot_programming.spot.detailedSchedule.${error.$property == 'fileName' ? 'spotFileName' : error.$property}`)).join(', ') })"></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { minValue, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import eventBus from '@/plugins/eventBus';
import moment from 'moment';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    // const clientCategories = computed(() => store.getters.clientCategory_categories({code: '', name: ''}));
    const listBusinessUnit = computed(() => store.getters.businessUnit_businessUnitList);
    const listProducts = computed(() => store.getters.product_productList);
    const listPrograms = computed(() => store.getters.show_programsList);
    const listspeakers = computed(() => store.getters.speaker_speakerList);
    const calculateTime = computed(() => time => moment().startOf('day').seconds(time).format('mm:ss'))
    const formType = ref(1);
    const invalidDates = ref(false);
    const submitted = ref(false);
    const model = ref({
      id: 0,
      startTime: '00:00',
      endTime: '00:00',
      occurrences: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      timeFee: 0,
      commercialBreakSpotPosition: 2,
      fileName: '',
      length: 0,
      spotType: 0,
      ntcText: '',
      showId: null,
      businessUnitId: null,
      speakerId: null,
      idBusinessShow: null,
      businessMonthlyFee: 0,
      groupId: null,
      productId: null,
      price: 0
    });

    onMounted(async () => {
      store.dispatch('loading_setActive', true);
      model.value['internalReferenceSpot'] = props.value.internalReferenceSpot;
      if (props.value.monthSelect) model.value.date = moment(props.value.monthSelect, 'YYYY-MM').format("YYYY-MM-DD")
      if (props.value.edit) model.value = Object.assign({}, props.value);
      
      // await store.dispatch('clientCategory_getAll');
      await store.dispatch('businessUnit_getAll');
      await store.dispatch('show_getAll');
      await store.dispatch('speaker_getAll');
      await store.dispatch('product_getAll', props.value.stationId);

      if (listProducts.value.length == 1) model.value.productId = listProducts.value[0].id

      // Detect paste in fileName
      document.getElementById("spotFileName").addEventListener("paste", event => {
        event.preventDefault();
        let paste = event.clipboardData.getData("text/data") || event.clipboardData.getData('text');
        changeSpotFileName(paste);
      })
      
      store.dispatch('loading_setActive', false);
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    async function saveAndClose() {
      submitted.value = true;
      // Validate custom
      const validateText = () => {
        if (model.value.spotType != 0) {
          return model.value.ntcText != '';
        }
        return true;
      }
      validateTimes();
      if (!v$.value.model.$invalid && !invalidDates.value && validateText()) {
        eventBus.$emit(props.value.edit ? 'editAdvancedSchedule' : 'addAdvancedSchedule', model.value);  
        this.closeModal();
      }
    }

    function validateTimes() {
      function _getMoment(time) {
        const [start, end] = time.split(":");
        return moment().hour(start).minutes(end);
      }

      if (model.value.startTime != '' && model.value.endTime != '') {
        // Validar que start sea distinto a end
        if (model.value.startTime == model.value.endTime) {
          invalidDates.value = true;
          return;
        }
        // Validar que start sea previo a end
        const startTimeValidate = _getMoment(model.value.startTime);
        const endTimeValidate = _getMoment(model.value.endTime);
        invalidDates.value = moment(startTimeValidate).isAfter(endTimeValidate);
      } else { 
        invalidDates.value = false;
      }
    }

    function changeSpotFileName(fileName) {
      const lastIndex = fileName.lastIndexOf(' *');
      if (lastIndex > -1) {
        model.value.length = Number(fileName.substring(lastIndex + 2));
        model.value.fileName = fileName.substring(0, lastIndex);
      } else {
        model.value.fileName = fileName
      }
    }

    function updateProduct() {
      const product = listProducts.value.find(product => product.id == model.value.productId);
      if (product) model.value.price = product.price;
    }

    function comparePriceProduct(productId, price) {
      const product = listProducts.value.find(product => product.id == productId);
      return product ? product.price != price : false;
    }

    function calculateTimeMention() {
      if (model.value.spotType == 1) {
        const qty = model.value.ntcText.split(' ');
        model.value.length = Math.round((qty.length + 1) * 0.4);
      }
    }
  
    return {
      v$,
      props,
      model,
      // clientCategories,
      formType,
      listBusinessUnit,
      listPrograms,
      listProducts,
      listspeakers,
      calculateTime,
      submitted,
      invalidDates,
      saveAndClose,
      closeModal,
      validateTimes,
      updateProduct,
      comparePriceProduct,
      calculateTimeMention
    }
  },
  validations () {
    return {
      model: {
        fileName: {required},
        length: {required, minValueValue: minValue(1)},
        startTime: {required},
        endTime: {required},
        productId: {required}
			}
    }
  }
};
</script>
<style lang="scss" scoped>
  label {
    overflow: hidden;
  }
  .time {
    position: absolute;
    top: 0px;
    color: black;
    background: gray;
    padding: 2px 8px;
    border-radius: 12px;
    margin-left: 4px;
    font-size: 12px;
  }
</style>